import type { EntityConfig } from '../types'

export const productEntity: EntityConfig = {
  id: 'product',
  displayName: 'Product',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'draft', label: 'Draft' },
      { value: 'archived', label: 'Archived' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'draft', label: 'Draft', color: 'warning' },
      { value: 'archived', label: 'Archived', color: 'error' },
    ],
    mappings: {
      all: ['active', 'draft', 'archived'],
      active: ['active'],
      draft: ['draft'],
      archived: ['archived'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    name: { type: 'search', urlKey: 'name' },
    sku: { type: 'search', urlKey: 'sku' },
    category: { type: 'string_array', urlKey: 'category' },
    priceRange: { type: 'amount', urlKey: 'price' },
    stockStatus: { type: 'string_array', urlKey: 'stock' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'status',
    'category',
  ]
}
